import ImageSB, { ImageSBProps } from '@/components/atoms/image/ImageSB';
import RichTextFieldSB, {
  RichTextFieldSBProps,
} from '@/components/atoms/richTextField/RichTextFieldSB';
import { Text } from '@/components/atoms/text';
import { BlockReference } from '@/components/cms/types/block';
import { BlockComponentModel } from '@/components/cms/types/blok-component';

import { BlockWrapper } from '@/features/utils/BlockWrapper';

import BlogAuthor from './AuthorItem';
import { getText } from '@/lib/i18n/i18n.server';

export interface AuthorItemStrapiProps {
  title: string;
  image: ImageSBProps;
  name: string;
  bio: RichTextFieldSBProps;
}

export interface AuthorStrapiProps {
  blogAuthor: Required<BlockReference<AuthorItemStrapiProps>>;
}

export async function AuthorStrapi({
  block,
}: BlockComponentModel<AuthorStrapiProps>) {
  const { blogAuthor } = block;
  const text = await getText();

  return (
    <BlockWrapper>
      <div data-tracker-section='blog-author'>
        <Text
          variant='h2'
          className='sm:text-h3 text-blog-body pb-5 font-bold sm:pb-6 '
        >
          {text.author.about_author}
        </Text>
        <BlogAuthor
          image={
            <ImageSB
              block={{
                ...blogAuthor.data?.attributes.image,
              }}
              inner={{
                classNames: { image: 'rounded-full' },
                width: 80,
                height: 80,
              }}
            />
          }
          name={blogAuthor.data?.attributes.name}
          title={blogAuthor.data?.attributes.title}
          bio={<RichTextFieldSB block={blogAuthor?.data?.attributes.bio} />}
        />
        <Text className='text-body-s text-neutral-N50 pt-8 sm:pt-12'>
          {text.author.disclaimer}
        </Text>
      </div>
    </BlockWrapper>
  );
}
